import { render } from "./BaseOverflowTooltip.vue?vue&type=template&id=e2f9f888&scoped=true"
import script from "./BaseOverflowTooltip.vue?vue&type=script&lang=js"
export * from "./BaseOverflowTooltip.vue?vue&type=script&lang=js"

import "./BaseOverflowTooltip.vue?vue&type=style&index=0&id=e2f9f888&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2f9f888"]])

export default __exports__